module.exports = __webpack_public_path__ + "img/v5.9e0a8b88.jpg";